import React from "react";
import { BackgroundCirclceSVG } from "./BackgroundSVG";

function MarketingBackgroundCircle() {
  return (
    <BackgroundCirclceSVG
      top={"-20%"}
      right={"-50px"}
      width="471"
      height="865"
      viewBox="0 0 471 865"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.16">
        <path
          d="M121.188 496.241C55.1341 354.588 116.419 186.209 258.072 120.155C399.725 54.1011 568.104 115.386 634.158 257.039C700.212 398.692 638.927 567.071 497.274 633.125C355.621 699.179 187.242 637.894 121.188 496.241Z"
          stroke="#707070"
        />
        <path
          d="M173.381 608.17C107.445 466.768 168.823 298.591 310.477 232.537C452.13 166.483 620.415 227.566 686.352 368.968C752.288 510.37 690.91 678.547 549.256 744.601C407.603 810.655 239.318 749.572 173.381 608.17Z"
          stroke="#707070"
        />
        <path
          d="M428.054 489.414C362.117 348.012 423.496 179.835 565.149 113.781C706.803 47.7272 875.087 108.811 941.024 250.212C1006.96 391.614 945.582 559.791 803.929 625.845C662.275 691.899 493.991 630.816 428.054 489.414Z"
          stroke="#707070"
        />
      </g>
    </BackgroundCirclceSVG>
  );
}

export default MarketingBackgroundCircle;
